import Model from '@/models/Model'

export default class WhDispatchRequest extends Model {
    resource() {
        return 'wh_dispatch_request'
    }

    inArmedToRevision(data) {
        return this.$http.put(
            this.baseURL() +
                '/' +
                this.resource() +
                `/${this.id}/in_armed_to_revision`,
            data
        )
    }

    inRevisionToInArmed(data) {
        return this.$http.put(
            this.baseURL() +
                '/' +
                this.resource() +
                `/${this.id}/in_revision_to_in_armed`,
            data
        )
    }

    inArmed() {
        return this.$http.put(
            this.baseURL() + '/' + this.resource() + `/${this.id}/in_armed`
        )
    }

    confirm(data) {
        return this.$http.put(
            this.baseURL() + '/' + this.resource() + `/${this.id}/confirm`,
            data
        )
    }

    get customerName() {
        return this.sl_customer ? this.sl_customer.alias_name : '-'
    }

    get customerBranchOfficeName() {
        return this.sl_customer_branch_offices
            ? `${
                  this.sl_customer_branch_offices.g_commune
                      ? this.sl_customer_branch_offices.g_commune.name + ' - '
                      : ''
              }` + this.sl_customer_branch_offices.address
            : '-'
    }

    get pchPaymentConditionText() {
        return this.pch_payment_condition
            ? this.pch_payment_condition.type
            : '-'
    }

    get creationDateString() {
        return this.creation_date
            ? this.creation_date
                  .substring(0, 10)
                  .split('-')
                  .reverse()
                  .join('-')
            : '-'
    }

    get gStateText() {
        return this.g_state ? this.g_state.state : '-'
    }

    get armerUserName() {
        return this.g_armer_user && this.g_armer_user.hr_employee
            ? this.g_armer_user.hr_employee.name_case
            : '-'
    }

    get armedDate() {
        return this.in_armed_to_revision_date
            ? this.in_armed_to_revision_date
                  .substring(0, 10)
                  .split('-')
                  .reverse()
                  .join('-')
            : '-'
    }

    get armedTime() {
        return this.in_armed_to_revision_date
            ? this.in_armed_to_revision_date.substring(11, 16)
            : '-'
    }
}
